import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import Section from '../shared/Section/Section';
import Container from '../shared/Container/Container';
import './Testimonials.css';

const Testimonials = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const testimonials = [
       {
      quote: "Finally, a gift for my grill-obsessed dad that he didn't already have.",
      author: "Ashley D.",
      role: "Happy Customer",
    },
  ];

  return (
    <Section background="beige">
      <Container>
        <div className="testimonials" ref={ref}>
          <motion.h2
            className="testimonials__title"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            Real BBQ Lovers, Real Results
          </motion.h2>

          <div className="testimonials__grid">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                className="testimonial-card"
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.2 + index * 0.2 }}
              >
                <div className="testimonial-card__quote">"{testimonial.quote}"</div>
                <div className="testimonial-card__author">
                  <strong>{testimonial.author}</strong>
                  <span>{testimonial.role}</span>
                </div>
                <div className="testimonial-card__stars">⭐⭐⭐⭐⭐</div>
              </motion.div>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Testimonials;
